import React, { useState } from "react";
import { render } from "react-email";
import ConsultationEmail from "../../emails/ConsultationEmail";
import Alert from "../Alert/Alert";

const ConsultationModal = ({ isOpen, onClose }) => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ NEW

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true); // ✅ start loading

    try {
      const emailHtml = await render(<ConsultationEmail values={form} />);

      const res = await fetch("https://gdesk-server.onrender.com/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ form, emailHtml }),
      });

      const data = await res.json();

      setAlert({ type: "success", message: data.message });

      setTimeout(() => {
        onClose();
        setAlert(null);
      }, 2000);
    } catch (error) {
      console.error(error);
      setAlert({ type: "error", message: "Something went wrong." });
    } finally {
      setLoading(false); // ✅ stop loading
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg">
        <h2 className="text-xl text-center font-bold mb-4">
          Book a Consultation
        </h2>

        {/* Alert */}
        {alert && (
          <Alert
            type={alert.type}
            message={alert.message}
            onClose={() => setAlert(null)}
          />
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {/* First Name */}
          <div>
            <label className="text-sm font-medium">First Name *</label>
            <input
              type="text"
              name="firstName"
              required
              onChange={handleChange}
              className="border p-2 rounded w-full mt-1"
            />
          </div>

          {/* Last Name */}
          <div>
            <label className="text-sm font-medium">Last Name *</label>
            <input
              type="text"
              name="lastName"
              required
              onChange={handleChange}
              className="border p-2 rounded w-full mt-1"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="text-sm font-medium">Phone Number</label>
            <input
              type="text"
              name="phone"
              onChange={handleChange}
              className="border p-2 rounded w-full mt-1"
            />
          </div>

          {/* Email */}
          <div>
            <label className="text-sm font-medium">Email *</label>
            <input
              type="email"
              name="email"
              required
              onChange={handleChange}
              className="border p-2 rounded w-full mt-1"
            />
          </div>

          {/* Message */}
          <div>
            <label className="text-sm font-medium">Message</label>
            <textarea
              name="message"
              placeholder="How can we help you?"
              onChange={handleChange}
              className="border p-2 rounded w-full mt-1 h-28 resize-none"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`py-2 rounded font-semibold transition flex items-center justify-center gap-2 ${
              loading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-primary text-white hover:opacity-90"
            }`}
          >
            {loading && (
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            )}

            {loading ? "Submitting..." : "Submit"}
          </button>

          {/* Cancel */}
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="text-gray-500 border border-gray-500 py-2 rounded text-sm mt-2 hover:bg-gray-100 transition"
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default ConsultationModal;
